var gallery_init = function(){
	debug && console.log('gallery_init');
	if (typeof $ == 'undefined' || typeof $.fn.slick == 'undefined') return;
	var $galleries = $('.w-gallery');
	$galleries.each(function(){
		var $me = $(this);
		var $main = $me.find('.w-gallery-main');
		var $nav = $me.find('.w-gallery-nav');
		var id = $main.attr('id');
		var id2 = $nav.attr('id');
		$main.slick({
			infinite: false,
			asNavFor: id2 ? '#' + id2 : '', 
			arrows: true,
			slidesToShow: 3,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
					}
				}, 
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
					}
				}, 
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 1,
					}
				}
			]
		});
		$nav.slick({
			infinite: false,
			asNavFor: id ? '#' + id : null, 
			slidesToShow: 12,
			focusOnSelect: true,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 9,
					}
				}, 
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 6,
					}
				}, 
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 3,
					}
				}
			]
		});
	});
};

init_scripts.push(gallery_init);